// eslint-disable-line no-unused-expressions
import React from "react";

import Backdrop from "../../../../../Components/UI/Backdrop/Backdrop";
import InfoTable, {
  InfoRow,
} from "../../../../../Components/PagesComponents/AnalysisReports/InfoTable/InfoTable";

import "./styles.scss";

const OSInformationCard = ({ osData }) => {
  return (
    <div className="thunter-information-card">
      <Backdrop show={false} absolute={true} />
      <h3 className="article">Operating System Information</h3>
      <InfoTable>
        <InfoRow label="OS Name" value={osData["name"]} />
        <InfoRow label="Version" value={osData["version"]} />
        <InfoRow label="Build" value={osData["build"]} />
        <InfoRow label="Support" value={osData["support_status"]} />
        <InfoRow label="Last Update" value={osData["last_update"]} />
      </InfoTable>
    </div>
  );
};

export default OSInformationCard;
